<template>
  <modal-frame
    :isVisible="props.isVisible"
    :width="'400px'"
    :isOverlay="false"
    @closeDialogHandler="closeHandler(0)"
  >
    <div class="modal_title">
      <h4>{{ $t("trading.transact.mm") }}</h4>
      <button class="close-btn" @click="closeHandler(0)">×</button>
    </div>
    <div class="modal_body">
      <p>{{ ticker }}USDT</p>
      <ul>
        <li
          :class="{ active: selectedType == item.key }"
          v-for="item in marginList"
          :key="item.key"
          @click="selectedType = item.key"
        >
          {{ item.value }}
        </li>
      </ul>
    </div>
    <div class="col-12 text-center modal_btn">
      <button type="button" class="btn-primary mlr-5" @click="closeHandler(1)">
        {{ $t("trading.common.confirm") }}
      </button>
    </div>
  </modal-frame>
</template>

<script setup>
import { defineProps, defineEmits, computed, onMounted, ref, watch } from "vue";
import ModalFrame from "@/components/common/modal/ModalFrame.vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const emit = defineEmits(["closeDialogHandler"]);
const props = defineProps({
  isVisible: { type: Boolean },
  marginType: { type: String },
  width: { type: String },
});
const store = useStore();
const marginList = [
  { key: "cross", value: t("trading.table.cross") },
  { key: "isolated", value: t("trading.table.isolated") },
];
const selectedType = ref(props.marginType);
const ticker = computed(() => store.state.transact.ticker);
const closeHandler = (bool) => {
  if (bool) {
    emit("closeDialogHandler", selectedType.value);
  } else {
    emit("closeDialogHandler");
    selectedType.value = props.marginType;
  }
};
watch(
  () => props.marginType,
  () => {
    selectedType.value = props.marginType;
  }
);
</script>

<style lang="scss" scoped>
@import url("@/assets/scss/components/common/modal.scss");
.modal_body {
  p {
    font-size: 18px;
  }
  ul {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    gap: 10px;
    li {
      width: 50%;
      text-align: center;
      border: 1px solid var(--line-color);
      border-radius: 5px;
      padding: 15px 5px;
      font-size:1.5rem;
      &.active {
        border: 1px solid var(--txt-default-color);
      }
    }
  }
}
</style>
